import axios from 'axios'

// 创建axios实例
const service = axios.create({
  // 生产环境直接使用/official/portal作为baseURL
  // 开发环境通过vue.config.js的proxy代理处理
  baseURL: process.env.NODE_ENV === 'production' ? '/official/portal' : '/api/official/portal',
  timeout: 60 * 1000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8;'
  }
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 可以在这里添加自定义请求头
    config.headers['X-Source-Site'] = 'ec-cn';
    config.headers['Bos-Access-Source'] = document.referrer ? document.referrer : -1;
    return config
  },
  error => {
    console.log(error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    return res
  },
  error => {
    console.log('err' + error)
    return Promise.reject(error)
  }
)

// 定义API接口
export const api = {
  // 获取页面列表
  getPageList: (params) => service.post('/page/list', params),
  // 发送联系消息
  sendContactMsg: (params) => service.post('/msg/sendContactMsg', params)
}

export default service
